export default "__VITE_ASSET__CCUi8dkz__"